import { useCallback, useEffect, useState } from "react";
import { App } from "antd";
import { getKermesPreorders } from "../utils/api";

export default function usePreorders() {
  const { message } = App.useApp();
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(false);

  const reload = useCallback(async () => {
    setLoading(true);
    try {
      const data = await getKermesPreorders();
      setOrders(data.preorders || []);
    } catch (error) {
      message.error(error.message);
    } finally {
      setLoading(false);
    }
  }, [message]);

  useEffect(() => {
    reload();
  }, [reload]);

  return { orders, loading, reload };
}
